type GlobLoader<T> = T | (() => T)
type GlobEntries<T> = Record<string, GlobLoader<T>>

type UseResolveAssetParams<T> = {
  path: string
  glob: () => GlobEntries<T>
}

export const useResolveAsset = <T>({ path, glob }: UseResolveAssetParams<T>): T | undefined => {
  // dynamically load assets on vite via glob extraction
  const file = Object.entries(glob())
    .filter(([fileName]) => {
      return fileName.replace(/^\/src/, '@').includes(path)
    })
  if (file.length) {
    const [, fileLoader] = file[0]
    return typeof fileLoader === 'function'
      ? (fileLoader as () => T)()
      : (fileLoader as T)
  }
}
